//推广详情

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 是否付费
 */
class HasPaid extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(2, "否");
}

export const HAS_PAID = new HasPaid();
